<mat-card>
    <mat-card-header>
      <mat-card-title>Gestión de {{'UnidadFuncional' | translate}}</mat-card-title>
      <mat-card-subtitle></mat-card-subtitle>
    </mat-card-header>

    <mat-card-content>

      <mat-label *ngIf="isValidating"><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
      <mat-label *ngIf="isSearching"><i class="fa fa-spinner fa-spin"></i> Buscando...</mat-label>
      <mat-label *ngIf="!isSearching && msgError.length > 0">{{msgError}}</mat-label>

      <div *ngIf="!isSearching && item != null">

        <ng-container *ngIf="canEdit">

          <mat-expansion-panel [expanded]="true">

            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon style="margin-top: -3px;">settings</mat-icon> Datos Generales
              </mat-panel-title>
              <mat-panel-description>
              </mat-panel-description>
            </mat-expansion-panel-header>

            <form [formGroup]="formGroup">

              <div fxLayout="row stretch" fxLayout.xs="column">

                <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                  <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label>Código*</mat-label>
                    <input matInput formControlName="Codigo" (keyup.enter)="onSearch()" maxlength="100">
                    <mat-error *ngIf="!formGroup.controls['Codigo'].valid && formGroup.controls['Codigo'].touched">
                      {{ getErrorCodigo() }}
                    </mat-error>
                  </mat-form-field>
                </div>
                <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                  <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label>Número*</mat-label>
                    <input matInput type="number" formControlName="Numero" (keyup.enter)="onGuardar()">
                    <mat-error *ngIf="!formGroup.controls['Numero'].valid && formGroup.controls['Numero'].touched">
                      {{ getErrorNumero() }}
                    </mat-error>
                  </mat-form-field>
                </div>

                <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                  <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label>Número Partida</mat-label>
                    <input matInput formControlName="NumeroPartida" (keyup.enter)="onGuardar()" maxlength="100">
                  </mat-form-field>
                </div>
                <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                  <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label *ngIf="!isTipoUnidadSearching">Tipo Unidad*</mat-label>
                    <mat-label *ngIf="isTipoUnidadSearching">Cargando...</mat-label>
                    <mat-select formControlName="TipoUnidad" (selectionChange)="onTipoUnidadSelect($event)">
                      <mat-option *ngFor="let s of tipoUnidadList" [value]="s">{{s.Nombre}}</mat-option>
                    </mat-select>
                    <mat-error *ngIf="!formGroup.controls['TipoUnidad'].valid && formGroup.controls['TipoUnidad'].touched">
                      {{ getErrorTipoUnidad() }}
                    </mat-error>
                  </mat-form-field>
                </div>

                <ng-container *ngIf="showComunidad">
                  <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                    <mat-form-field appearance="outline" style="width: 100%">
                      <mat-label *ngIf="!isComunidadSearching">{{'Comunidad' | translate}}*</mat-label>
                      <mat-label *ngIf="isComunidadSearching">Cargando...</mat-label>
                      <mat-select formControlName="ComunidadId" (selectionChange)="onComunidadSelect()">
                        <mat-option *ngFor="let s of comunidadList" [value]="s.Id">{{s.Nombre}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                    <mat-form-field appearance="outline" style="width: 100%">
                      <mat-label>Número Piso</mat-label>
                      <input matInput type="number" formControlName="NroPiso" (keyup.enter)="onGuardar()">
                    </mat-form-field>
                  </div>
                </ng-container>
                <ng-container *ngIf="!showComunidad && tenantFeatureFlags?.HabilitarGestionConsorcio">
                  <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                    <mat-form-field appearance="outline" style="width: 100%">
                      <mat-label *ngIf="!isConsorcioSearching">Consorcio*</mat-label>
                      <mat-label *ngIf="isConsorcioSearching">Cargando...</mat-label>
                      <mat-select formControlName="ConsorcioId">
                        <mat-option *ngFor="let s of consorcioList" [value]="s.Id">{{s.Nombre}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                  </div>
                </ng-container>

                <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                  <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label>M² Cubiertos</mat-label>
                    <input matInput type="number" formControlName="MetrosCuadradosCubiertos" (keyup.enter)="onGuardar()">
                  </mat-form-field>
                </div>
                <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                  <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label>M² Descubiertos</mat-label>
                    <input matInput type="number" formControlName="MetrosCuadradosDescubiertos" (keyup.enter)="onGuardar()">
                  </mat-form-field>
                </div>

                <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                  <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label>Cantidad Ambientes</mat-label>
                    <input matInput type="number" formControlName="CantidadAmbientes" type="number" (keyup.enter)="onGuardar()">
                  </mat-form-field>
                </div>
                <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                  <mat-form-field appearance="outline" style="width: 100%" >
                    <mat-label>Fecha Entrega</mat-label>
                    <input matInput [matDatepicker]="fechaEntregaPicker" formControlName="FechaEntrega"  (click)="fechaEntregaPicker.open()">
                    <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaEntregaPicker">
                    </mat-datepicker-toggle>
                    <mat-datepicker-toggle style="display:inline-block;" matSuffix (click)="clearDate('FechaEntrega')">
                      <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                    </mat-datepicker-toggle>
                    <mat-datepicker #fechaEntregaPicker></mat-datepicker>
                  </mat-form-field>
                </div>

                <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                  <mat-form-field appearance="outline" style="width: 100%" >
                    <mat-label>Fecha Escrituración</mat-label>
                    <input matInput [matDatepicker]="fechaEscrituracionPicker" formControlName="FechaEscrituracion"  (click)="fechaEscrituracionPicker.open()">
                    <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaEscrituracionPicker">
                    </mat-datepicker-toggle>
                    <mat-datepicker-toggle style="display:inline-block;" matSuffix (click)="clearDate('FechaEscrituracion')">
                      <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                    </mat-datepicker-toggle>
                    <mat-datepicker #fechaEscrituracionPicker></mat-datepicker>
                  </mat-form-field>
                </div>
                <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                  <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label *ngIf="!isMonedaSearching">Moneda</mat-label>
                    <mat-label *ngIf="isMonedaSearching">Cargando...</mat-label>
                    <mat-select formControlName="MonedaId">
                      <mat-option *ngFor="let s of monedaList" [value]="s.Id">{{s.Codigo}} - {{s.Nombre}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                  <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label>Precio</mat-label>
                    <input matInput type="number" formControlName="Precio" (keyup.enter)="onGuardar()">
                  </mat-form-field>
                </div>
                <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                  <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label>Valuación Fiscal</mat-label>
                    <input matInput type="number" formControlName="ValuacionFiscal" (keyup.enter)="onGuardar()">
                  </mat-form-field>
                </div>

                <div fxFlex=100 fxFlex.xs=100 class="flex-item">
                  <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label>Observaciones</mat-label>
                    <input matInput formControlName="Observaciones" (keyup.enter)="onGuardar()" maxlength="300">
                    <mat-error *ngIf="!formGroup.controls['Observaciones'].valid && formGroup.controls['Observaciones'].touched">
                      {{ getErrorObservaciones() }}
                    </mat-error>
                  </mat-form-field>
                </div>

              </div>

            </form>

            <div fxLayout="row stretch" fxLayout.xs="column">
              <div fxFlex=33.33 fxFlex.xs=100 class="flex-item">
                <mat-checkbox [(ngModel)]="item.Activo" (keyup.enter)="onGuardar()" color="primary">Activo</mat-checkbox>
              </div>
            </div>

          </mat-expansion-panel>

          <br/>

          <mat-expansion-panel [expanded]="true">

            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon style="margin-top: -3px;">attach_file</mat-icon> Adjuntos
              </mat-panel-title>
              <mat-panel-description>
              </mat-panel-description>
            </mat-expansion-panel-header>

            <div fxLayout="row stretch" fxLayout.xs="column">

              <div fxFlex=100 fxFlex.xs=100 class="flex-item" style="margin:10px;">
                  <mat-nav-list>
                      <mat-list-item *ngFor="let file of item.Adjuntos" style="background-color: lightgray; margin: 5px 0px;border-radius: 10px;">
                          <a matLine href="{{file.UrlDocumento}}" target="_blank">{{file.NombreDocumento}}</a>
                          <button mat-icon-button (click)="onFileAttachedDelete(file)" title="Eliminar adjunto">
                              <i class="fa fa-trash fa-1x"></i>
                          </button>
                      </mat-list-item>
                      </mat-nav-list>
              </div>

              <div fxFlex=100 fxFlex.xs=100 class="flex-item" style="margin:10px;">
                  <button mat-icon-button matSuffix (click)="fileInput.click()" [disabled]="isFileAttaching"><mat-icon style="margin-right: 5px;">attach_file</mat-icon> Agregar adjunto</button>
                  <input hidden (change)="onNewFileAttach($event)" #fileInput type="file" multiple>
                  <mat-label *ngIf="isFileAttaching"><br/><i class="fa fa-spinner fa-spin"></i> Subiendo archivo...</mat-label>
              </div>

            </div>

          </mat-expansion-panel>

          <ng-container *ngIf="tenantFeatureFlags?.HabilitarControlExpensas && !esUsuarioFinal">

            <br/>

            <mat-expansion-panel [expanded]="true">

              <mat-expansion-panel-header>
                  <mat-panel-title>
                    <mat-icon style="margin-right: 5px;">list</mat-icon> Porcentajes para Expensas
                  </mat-panel-title>
                  <mat-panel-description>
                  </mat-panel-description>
              </mat-expansion-panel-header>

              <form [formGroup]="ufTipoGastoFormGroup">

                <div fxLayout="row stretch" fxLayout.xs="column">

                  <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                    <mat-form-field appearance="outline" style="width: 100%">
                      <mat-label *ngIf="!isTipoGastoSearching">Tipo Gasto*</mat-label>
                      <mat-label *ngIf="isTipoGastoSearching">Cargando...</mat-label>
                      <mat-select formControlName="TipoGasto" (selectionChange)="onTipoGastoSelect()" [compareWith]="compareTiposGastos">
                        <mat-option [value]="{ Id: 0, Nombre: 'Todos' }">Todos</mat-option>
                        <mat-option *ngFor="let s of tipoGastoList" [value]="s">{{s.Nombre}}</mat-option>
                      </mat-select>
                      <mat-error *ngIf="!ufTipoGastoFormGroup.controls['TipoGasto'].valid && ufTipoGastoFormGroup.controls['TipoGasto'].touched">
                        {{ getErrorTipoGasto() }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div fxFlex=40 fxFlex.xs=100 class="flex-item">
                    <mat-form-field appearance="outline" style="width: 100%">
                      <mat-label>Porcentaje*</mat-label>
                      <input matInput type="number" formControlName="Porcentaje" (keyup.enter)="onUfTipoGastoAdd()" maxlength="100">
                      <mat-error *ngIf="!ufTipoGastoFormGroup.controls['Porcentaje'].valid && ufTipoGastoFormGroup.controls['Porcentaje'].touched">
                        {{ getErrorPorcentaje() }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div fxFlex=10 fxFlex.xs=100 class="flex-item" style="margin-top:10px;"align="end">
                    <div fxLayout="row stretch" fxLayout.xs="column">
                      <button mat-raised-button (click)="onUfTipoGastoAdd()" [disabled]="isProcessing()" color="primary" class="zb-button">Guardar</button>
                    </div>
                  </div>

                </div>

                <div fxLayout="row stretch" fxLayout.xs="column">
                  <div fxFlex=100 fxFlex.xs=100 fxLayoutAlign="center" class="flex-item" style="border-radius: 10px; background-color: lightblue; padding-bottom: 15px;">
                    <mat-label style="font-weight: bold; text-align: center; padding-top: 15px;">
                      <u>NOTA:</u> si queres asignar el mismo porcentaje para todos los tipos de gastos disponibles, carga un porcentaje y selecciona <i>Todos</i> en los tipos de gastos.
                    </mat-label>
                  </div>
                </div>

              </form>

              <div fxLayout="row stretch" fxLayout.xs="column" style="padding: 15px 0px;">
                <ejs-grid #grid [dataSource]='item.GastosPorcentajes' [allowPaging]="true" [allowSorting]="true" [toolbar]='toolbarOptions'
                  [selectionSettings]='selectionOptions' [pageSettings]='pageSettings' [allowResizing]='true'>
                  <e-columns>
                    <e-column field='TipoGasto' headerText='Tipo Gasto' width=150></e-column>
                    <e-column field='Porcentaje' headerText='Porcentaje UF' width=100>
                      <ng-template #template let-data>
                        {{data.Porcentaje | number: '1.2-2'}}%
                      </ng-template>
                    </e-column>
                    <e-column field='PorcentajeAcumulado' headerText='Acumulado de Comunidad' width=100>
                      <ng-template #headerTemplate let-data>
                        Acumulado de {{'Comunidad' | translate}}
                      </ng-template>
                      <ng-template #template let-data>
                        {{data.PorcentajeAcumulado | number: '1.2-2'}}%
                      </ng-template>
                    </e-column>
                    <e-column headerText='Acciones' width=90>
                      <ng-template #template let-data>
                        <a style="cursor: pointer; margin-right: 5px" (click)="onUfTipoGastoView(data)"><i class="fa fa-eye fa-1x"></i></a>
                        <a style="cursor: pointer; margin-right: 5px" (click)="onUfTipoGastoDelete(data)"><i class="fa fa-trash fa-1x"></i></a>
                      </ng-template>
                    </e-column>
                  </e-columns>
                </ejs-grid>
              </div>

              <div fxLayout="row stretch" fxLayout.xs="column">
                <div fxFlex=100 fxFlex.xs=100 class="flex-item" style="margin: 10px 0 20px 0; text-align: center;">
                  <div fxFlex=100 fxFlex.xs=100 fxLayoutAlign="center" class="flex-item" style="border-radius: 10px; background-color: indianred; padding-bottom: 15px;">
                    <mat-label style="font-weight: bold; text-align: center; padding-top: 15px;">
                      <u>AVISO:</u> tené en cuenta que la edición individual de estos porcentajes puede afectar al porcentaje total de {{('Comunidad' | translate).toLowerCase()}} e impactará en el cálculo de expensas a futuro.
                    </mat-label>
                  </div>
                </div>
              </div>

            </mat-expansion-panel>

          </ng-container>

        </ng-container>

        <ng-container *ngIf="!canEdit">

          <mat-expansion-panel [expanded]="true">

            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon style="margin-top: -3px;">settings</mat-icon> Datos Generales
              </mat-panel-title>
              <mat-panel-description>
              </mat-panel-description>
            </mat-expansion-panel-header>

            <div fxLayout="row stretch" class="zb-readonly">

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label><b>Código</b>: {{item.Codigo}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label><b>Número</b>: {{item.Numero}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label><b>Número de Partida</b>: {{item.NumeroPartida}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label><b>Tipo Unidad</b>: {{item.TipoUnidadNombre}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>

              <ng-container *ngIf="showComunidad">
                <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                  <mat-expansion-panel [expanded]="true" hideToggle="true">
                    <div fxLayout="row stretch" fxLayout.xs="column">
                      <mat-label><b>{{'Comunidad' | translate}}</b>: {{item.Comunidad}}</mat-label>
                    </div>
                  </mat-expansion-panel>
                </div>
                <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                  <mat-expansion-panel [expanded]="true" hideToggle="true">
                    <div fxLayout="row stretch" fxLayout.xs="column">
                      <mat-label><b>Número Piso</b>: {{item.NroPiso}}</mat-label>
                    </div>
                  </mat-expansion-panel>
                </div>
              </ng-container>
              <ng-container *ngIf="!showComunidad">
                <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                  <mat-expansion-panel [expanded]="true" hideToggle="true">
                    <div fxLayout="row stretch" fxLayout.xs="column">
                      <mat-label><b>Consorcio</b>: {{item.Consorcio}}</mat-label>
                    </div>
                  </mat-expansion-panel>
                </div>
                <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                </div>
              </ng-container>

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label><b>M² Cubiertos</b>: {{item.MetrosCuadradosCubiertos | number: '1.2-2'}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label><b>M² Descubiertos</b>: {{item.MetrosCuadradosDescubiertos | number: '1.2-2'}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label><b>Cantidad Ambientes</b>: {{item.CantidadAmbientes}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>

              <ng-container *ngIf="!esUsuarioFinal">

                <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                  <mat-expansion-panel [expanded]="true" hideToggle="true">
                    <div fxLayout="row stretch" fxLayout.xs="column">
                      <mat-label><b>Fecha Entrega</b>: {{item.FechaEntrega | date: 'dd/MM/yyyy'}}</mat-label>
                    </div>
                  </mat-expansion-panel>
                </div>
                <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                  <mat-expansion-panel [expanded]="true" hideToggle="true">
                    <div fxLayout="row stretch" fxLayout.xs="column">
                      <mat-label><b>Fecha Escrituración</b>: {{item.FechaEscrituracion | date: 'dd/MM/yyyy'}}</mat-label>
                    </div>
                  </mat-expansion-panel>
                </div>

                <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                  <mat-expansion-panel [expanded]="true" hideToggle="true">
                    <div fxLayout="row stretch" fxLayout.xs="column">
                      <mat-label><b>Moneda</b>: {{item.Moneda}}</mat-label>
                    </div>
                  </mat-expansion-panel>
                </div>
                <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                  <mat-expansion-panel [expanded]="true" hideToggle="true">
                    <div fxLayout="row stretch" fxLayout.xs="column">
                      <mat-label><b>Precio</b>: {{item.Precio | number: '1.2-2'}}</mat-label>
                    </div>
                  </mat-expansion-panel>
                </div>

                <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                  <mat-expansion-panel [expanded]="true" hideToggle="true">
                    <div fxLayout="row stretch" fxLayout.xs="column">
                      <mat-label><b>Valuación Fiscal</b>: {{item.ValuacionFiscal | number: '1.2-2'}}</mat-label>
                    </div>
                  </mat-expansion-panel>
                </div>
                <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                  <mat-expansion-panel [expanded]="true" hideToggle="true">
                    <div fxLayout="row stretch" fxLayout.xs="column">
                      <mat-label><b>Activo</b>: {{item.Activo ? 'Sí' : 'No'}}</mat-label>
                    </div>
                  </mat-expansion-panel>
                </div>

                <div fxFlex=100 fxFlex.xs=100 class="flex-item">
                  <mat-expansion-panel [expanded]="true" hideToggle="true">
                    <div fxLayout="row stretch" fxLayout.xs="column">
                      <mat-label><b>Observaciones</b>: {{item.Observaciones}}</mat-label>
                    </div>
                  </mat-expansion-panel>
                </div>

              </ng-container>

            </div>

          </mat-expansion-panel>

          <br/>

          <mat-expansion-panel [expanded]="true">

            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon style="margin-top: -3px;">attach_file</mat-icon> Adjuntos
              </mat-panel-title>
              <mat-panel-description>
              </mat-panel-description>
            </mat-expansion-panel-header>

            <div fxLayout="row stretch" fxLayout.xs="column">

                <div fxFlex=100 fxFlex.xs=100 class="flex-item" style="margin:10px;" *ngIf="isAttachmentSearching">
                  <mat-label><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
                </div>
                <div fxFlex=100 fxFlex.xs=100 class="flex-item" style="margin:10px;" *ngIf="!isAttachmentSearching">
                  <mat-nav-list>
                  <mat-list-item *ngFor="let file of item.Adjuntos" style="background-color: lightgray; margin: 5px 0px;border-radius: 10px;">
                    <a matLine href="{{file.UrlDocumento}}" target="_blank">{{file.NombreDocumento}}</a>
                  </mat-list-item>
                  </mat-nav-list>
                </div>
            </div>

          </mat-expansion-panel>

          <ng-container *ngIf="tenantFeatureFlags?.HabilitarControlExpensas && !esUsuarioFinal">

            <br/>

            <mat-expansion-panel [expanded]="true">

              <mat-expansion-panel-header>
                  <mat-panel-title>
                    <mat-icon style="margin-right: 5px;">list</mat-icon> Porcentajes para Expensas
                  </mat-panel-title>
                  <mat-panel-description>
                  </mat-panel-description>
              </mat-expansion-panel-header>

              <div fxLayout="row stretch" fxLayout.xs="column">
                <ejs-grid #grid [dataSource]='item.GastosPorcentajes' [allowPaging]="true" [allowSorting]="true" [toolbar]='toolbarOptions'
                  [selectionSettings]='selectionOptions' [pageSettings]='pageSettings' [allowResizing]='true'>
                  <e-columns>
                    <e-column field='TipoGasto' headerText='Tipo Gasto' width=150></e-column>
                    <e-column field='Porcentaje' headerText='Porcentaje' width=100>
                      <ng-template #template let-data>
                        {{data.Porcentaje | number: '1.2-2'}}%
                      </ng-template>
                    </e-column>
                  </e-columns>
                </ejs-grid>
              </div>

            </mat-expansion-panel>

          </ng-container>

        </ng-container>

        <!-- Incidencias -->
        <ng-container *ngIf="item.Id > 0 && canViewIncidencias">

          <br/>

          <mat-expansion-panel [expanded]="true" hideToggle="true">

            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon style="margin-right: 5px;">error</mat-icon> Incidencias Asociadas
              </mat-panel-title>
              <mat-panel-description>
              </mat-panel-description>
            </mat-expansion-panel-header>

            <div fxLayout="row stretch" fxLayout.xs="column" style="margin-top: 10px;">

              <div fxFlex=100 fxFlex.xs=100 class="flex-item">

                <mat-label *ngIf="isIncidenciasSearching">Buscando...</mat-label>
                <ejs-grid #gridIncidencias [dataSource]='incidenciasList' [allowPaging]="true"
                  [allowSorting]="true" *ngIf="!isIncidenciasSearching" [selectionSettings]='selectionOptions'
                  [pageSettings]='pageSettings' [allowResizing]='true'>
                  <e-columns>
                    <e-column field='Id' headerText='#' width=60></e-column>
                    <e-column field='FechaUltimoMensaje' headerText='Fecha Ult. Actualización' type="Date" format="dd/MM/yyyy HH:mm" width=60></e-column>
                    <e-column field='IncidenciaUsuarioCategoriaNombre' headerText='Categoría' width=90></e-column>
                    <e-column field='ComunidadNombre' headerText='Comunidad' width=90>
                      <ng-template #headerTemplate let-data>
                        <div>
                          {{ 'Comunidad' | translate }}
                        </div>
                      </ng-template>
                    </e-column>
                    <e-column field='EstadoNombre' headerText='Estado' width=90></e-column>
                    <e-column field='Asunto' headerText='Asunto' width=120></e-column>
                    <e-column headerText='Acciones' width=40>
                      <ng-template #template let-data>
                        <a style="cursor: pointer; margin-right: 18px" (click)="viewIncidencia(data.Id)">
                          <mat-icon style="width: 5px; font-size: 18px;" title="Ver incidencia">visibility</mat-icon>
                        </a>
                      </ng-template>
                    </e-column>

                  </e-columns>
                </ejs-grid>

              </div>

            </div>

          </mat-expansion-panel>

        </ng-container>

        <ng-container *ngIf="item != null && item.Id > 0 && canViewSaldos">

          <br/>

          <mat-expansion-panel [expanded]="true" hideToggle="true">

            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon style="margin-right: 5px;">monetization_on</mat-icon> Resumen de Saldos
              </mat-panel-title>
              <mat-panel-description>
              </mat-panel-description>
            </mat-expansion-panel-header>

            <div fxLayout="row stretch" fxLayout.xs="column" style="margin-top: 10px;" *ngIf="isSaldosSearching">
              <mat-label>Buscando...</mat-label>
            </div>

            <ng-container *ngIf="!isSaldosSearching">

              <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly" *ngIf="saldosList == null || saldosList.length == 0" >
                <mat-label>No hay saldos para mostrar.</mat-label>
              </div>

              <ng-container *ngIf="saldosList != null && saldosList.length > 0">

                <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly" style="margin-top: 10px;" *ngFor="let saldo of saldosList" >

                  <div fxFlex=25 fxFlex.xs=100 class="flex-item">
                    <mat-expansion-panel [expanded]="true" hideToggle="true">
                      <div fxLayout="row stretch" fxLayout.xs="column">
                        <mat-label>
                          <b>Saldo Total</b>:
                          <span style="margin-left: 5px;" [ngStyle]="{ color: (saldo.SaldoTotal < 0) ? 'indianred' : 'black' }">{{saldo.Moneda}} {{saldo.SaldoTotal | number: '1.2-2'}}</span>
                        </mat-label>
                      </div>
                    </mat-expansion-panel>
                  </div>
                  <div fxFlex=25 fxFlex.xs=100 class="flex-item">
                    <mat-expansion-panel [expanded]="true" hideToggle="true">
                      <div fxLayout="row stretch" fxLayout.xs="column">
                        <mat-label><b>Saldo A Favor</b>: {{saldo.Moneda}} {{saldo.SaldoAFavor | number:'1.2-2'}}</mat-label>
                      </div>
                    </mat-expansion-panel>
                  </div>
                  <div fxFlex=25 fxFlex.xs=100 class="flex-item">
                    <mat-expansion-panel [expanded]="true" hideToggle="true">
                      <div fxLayout="row stretch" fxLayout.xs="column">
                        <mat-label><b>Saldo Deudor</b>: {{saldo.Moneda}} {{saldo.SaldoDeudor | number:'1.2-2'}}</mat-label>
                      </div>
                    </mat-expansion-panel>
                  </div>
                  <div fxFlex=25 fxFlex.xs=100 class="flex-item">
                    <mat-expansion-panel [expanded]="true" hideToggle="true">
                      <div fxLayout="row stretch" fxLayout.xs="column">
                        <mat-label><b>Saldo Vencido</b>: {{saldo.Moneda}} {{saldo.SaldoVencido | number:'1.2-2'}}</mat-label>
                      </div>
                    </mat-expansion-panel>
                  </div>

                </div>

              </ng-container>

            </ng-container>

          </mat-expansion-panel>

        </ng-container>

      </div>

    </mat-card-content>

    <mat-card-actions style="margin-bottom: 20px;">
      <div fxLayout="row stretch" fxLayout.xs="column">
        <button mat-raised-button (click)="onGuardar()" *ngIf="canEdit" [disabled]="isProcessing()" color="primary" class="zb-button">{{isSaving ? 'Guardando...' : 'Guardar'}}</button>
        <button mat-raised-button (click)="onCancel()" color="warn" class="zb-button">{{canEdit ? 'Cancelar' : 'Cerrar'}}</button>
        <button mat-raised-button (click)="onDelete()" *ngIf="canDelete && item != null && item.Id > 0" [disabled]="isProcessing()" color="secondary" class="zb-button">
          {{ isDeleting ? 'Eliminando...' : 'Eliminar' }}
        </button>
      </div>
    </mat-card-actions>

  </mat-card>
